import { FC, useMemo } from 'react'

import {KTSVG} from '../../../../../_metronic/helpers'

type Props = {
    siteState: string    
    doClose: Function
}
const SiteApplicationResponseHeader: FC<Props> = ({siteState, doClose}) => {

    const { headerText, subText } = useMemo(() => {
        
        let headerText = siteState;
        let subText = '';
        switch(siteState) {
            case 'Pending Application': 
                subText = 'Submit documents.'
                break;
            default: 
                break;
        }

        return { headerText, subText }
    }, [siteState]);


    return (
    <div className='modal-header'>      
        <div>        
            <h2 className='fw-bolder'>
                {headerText}          
            </h2>
            { subText && 
            <div className="text-muted fw-light fs-6 mt-2">{subText}</div> 
            }

        </div>
        <div
            className='btn btn-icon btn-sm btn-active-icon-danger'
            data-kt-producttypes-modal-action='close'        
            style={{cursor: 'pointer'}}
            onClick={() => doClose()}
        >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
        </div>      
    </div>
    )
}

export {SiteApplicationResponseHeader}
